import { useSelector } from 'react-redux';

import useSolutions from 'lib/hooks/useSolutions';
import useInteractions from 'lib/hooks/useInteractions';

import { selectCurrentUser } from 'features/auth/slice';

import {
  flash,
  Icon,
  pluralize,
  recordsContain,
  recordsMatch,
} from '@frontendmentorio/design-system-v2';

import withAuth from 'features/shared/withAuth';

const AuthButton = withAuth(({ ...props }) => <button {...props} />);

export default function LikeButton({ className, isCompact, solution }) {
  const currentUser = useSelector(selectCurrentUser);
  const { like } = useSolutions();
  const { getInteractions } = useInteractions();
  const { likes } = getInteractions(solution);

  const isCurrentUserSolution = recordsMatch(currentUser, solution.user);
  const isLiked = recordsContain(likes, currentUser);

  const handleLike = async () => {
    try {
      await like(solution);
    } catch (error) {
      flash.error(error.message);
    }
  };

  return (
    <AuthButton
      aria-label={`${
        isLiked ? 'Unlike' : 'Like'
      } this solution. This solution has ${pluralize(likes.length, 'like')}`}
      className={className}
      disabled={isCurrentUserSolution}
      level="tertiary"
      onClick={handleLike}
    >
      {isCompact ? (
        <>
          <Icon
            className={isLiked ? 'text-rose-600' : 'text-neutral-500'}
            name="heart"
            style="solid"
          />

          <span className="text-sm">{pluralize(likes.length, 'like')}</span>
        </>
      ) : (
        <>
          <Icon
            className={isLiked ? 'text-rose-600' : 'text-neutral-500'}
            name="heart"
            style={isLiked ? 'solid' : 'regular'}
          />

          <span>{likes.length}</span>
        </>
      )}
    </AuthButton>
  );
}
